import React, { useRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import noUser from '../../assets/img/no_user.jpg';
import { hotFixCreateBlobUrl } from '../../helper/binarytoblob';
import { useEffect } from 'react';

// const RATIO = {
//   FULLSCREEN: 9 / 16,
//   LOGO: 1,
// };

const CropperImage = ({
  path,
  setBlobURL,
  setTab,
  blobURL,
  setShowImageEditor,
  setPreviewScreen,
  imageEditData,
  setImageEditData,
  setMarkerState,

  type = 'fullscreen',
}) => {
  const cropperRef = useRef(null);

  const handleClickButton = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    const data = cropper
      .getCroppedCanvas({
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
        // minWidth: 600,
        // maxWidth: 1024,
        minWidth: 1200,
        maxWidth: 2048,
      })
      .toDataURL('image/jpeg', 0.95);

    const test = hotFixCreateBlobUrl(data);

    // const blob = CreateBlobUrl(data);
    // const test = URL.createObjectURL(blob);
    setBlobURL({ ...blobURL, current: test, next: test });
    setTab(2);
  };

  useEffect(() => {
    setMarkerState && setMarkerState(null);
    // eslint-disable-next-line
    // cropper-crop-box
    const currentCropper = cropperRef.current;
    if (currentCropper) {
      const cropper = currentCropper.cropper;
      setTimeout(() => {
        if (cropper.cropBox) {
          let div = document.createElement('div');
          div.setAttribute('class', 'custom-cropper-box'); // and make sure myclass has some styles in css
          cropper.cropBox.appendChild(div);
        }
      }, 200);
    }
  }, []);

  const cropperOptions = {
    fullscreen: {
      initialAspectRatio: 9 / 16,
      aspectRatio: 9 / 16,
      minCanvasWidth: 200,
      minCropBoxWidth: 300,
      minContainerWidth: 500,
    },
    logo: {
      initialAspectRatio: 1,
      aspectRatio: 1,
    },
  };

  return (
    <>
      <Cropper
        dragMode='move'
        responsive={true}
        src={path}
        style={{ width: '100%' }}
        // initialAspectRatio={RATIO[type]}
        // aspectRatio={RATIO[type]}
        ref={cropperRef}
        minContainerHeight={'150px'}
        autoCropArea={1}
        autoCrop={true}
        className='cropper-img-main'
        checkOrientation={true}
        viewMode={0}
        // minCanvasWidth={200}
        // minCropBoxWidth={300}
        // minContainerWidth={500}
        guides={false}
        zoomable={true}
        cropBoxResizable={false}
        {...cropperOptions[type]}
      />
      <div className='img-editing-action-btn'>
        <button
          className='btn btn-primary'
          onClick={() => {
            setShowImageEditor(false);
            setPreviewScreen((prevState) => ({
              ...prevState,
              image: imageEditData ? imageEditData : noUser,
              // image: imageEditData ? imageEditData : prevState.image ?? noUser,
            }));
            setImageEditData && setImageEditData(null);
          }}>
          Cancel
        </button>
        <button className='btn btn-primary' onClick={handleClickButton}>
          Next
        </button>
      </div>
    </>
  );
};

export default CropperImage;
